module.exports = __webpack_public_path__ + "img/play-button.c017c7ed.svg";